import { format } from 'date-fns';
import { getDateLocale } from '../../../lib/dateLocale';

export function formatLastVisit(
    value: string | Date | undefined | null,
): string | null {
    if (!value) return null;
    return format(new Date(value), 'd MMM yyyy - HH:mm', {
        locale: getDateLocale(),
    });
}
